<template>
  <div class="min-h-screen flex items-center justify-center bg-bochas-bg px-4 py-12">
    <div class="w-full max-w-md">
      <!-- Logo -->
      <div class="flex flex-col items-center mb-8">
        <img
          src="@/assets/images/logoFederacion.png"
          alt="Federación de Bochas Córdoba"
          class="w-20 h-20 mb-4 object-contain"
        />
        <h1 class="text-xl font-bold text-white text-center">
          Cambio de contraseña
        </h1>
        <p class="text-gray-400 text-sm mt-2 text-center">
          Por seguridad, debés cambiar tu contraseña antes de continuar.
        </p>
      </div>

      <!-- Card -->
      <div class="card-fbochas p-6 sm:p-8">
        <form @submit.prevent="onSubmit" class="space-y-5">
          <!-- Contraseña actual -->
          <div>
            <label class="block text-sm font-medium text-gray-300 mb-2">
              Contraseña actual
            </label>
            <div class="relative">
              <input
                v-model="form.currentPassword"
                :type="showCurrent ? 'text' : 'password'"
                required
                autocomplete="current-password"
                class="w-full px-4 py-3 pr-12 bg-bochas-bg border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-bochas-rojo"
                placeholder="••••••••"
              />
              <button
                type="button"
                @click="showCurrent = !showCurrent"
                class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-white p-1"
              >
                <svg v-if="showCurrent" xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                  <line x1="1" y1="1" x2="23" y2="23" />
                </svg>
                <svg v-else xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                  <circle cx="12" cy="12" r="3" />
                </svg>
              </button>
            </div>
          </div>

          <!-- Nueva contraseña -->
          <div>
            <label class="block text-sm font-medium text-gray-300 mb-2">
              Nueva contraseña
              <span class="text-gray-500 text-xs ml-2">(mínimo 6 caracteres)</span>
            </label>
            <div class="relative">
              <input
                v-model="form.newPassword"
                :type="showNew ? 'text' : 'password'"
                required
                minlength="6"
                autocomplete="new-password"
                class="w-full px-4 py-3 pr-12 bg-bochas-bg border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-bochas-rojo"
                placeholder="••••••••"
              />
              <button
                type="button"
                @click="showNew = !showNew"
                class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-white p-1"
              >
                <svg v-if="showNew" xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                  <line x1="1" y1="1" x2="23" y2="23" />
                </svg>
                <svg v-else xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                  <circle cx="12" cy="12" r="3" />
                </svg>
              </button>
            </div>
          </div>

          <!-- Confirmar nueva -->
          <div>
            <label class="block text-sm font-medium text-gray-300 mb-2">
              Repetir nueva contraseña
            </label>
            <div class="relative">
              <input
                v-model="form.confirmPassword"
                :type="showConfirm ? 'text' : 'password'"
                required
                minlength="6"
                class="w-full px-4 py-3 pr-12 bg-bochas-bg border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-bochas-rojo"
                placeholder="••••••••"
              />
              <button
                type="button"
                @click="showConfirm = !showConfirm"
                class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-white p-1"
              >
                <svg v-if="showConfirm" xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path d="M17.94 17.94A10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                  <line x1="1" y1="1" x2="23" y2="23" />
                </svg>
                <svg v-else xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                  <circle cx="12" cy="12" r="3" />
                </svg>
              </button>
            </div>
          </div>

          <!-- Error -->
          <div
            v-if="error"
            class="bg-bochas-rojo/20 border border-bochas-rojo text-red-200 text-sm rounded-lg px-4 py-3"
          >
            {{ error }}
          </div>

          <!-- Submit -->
          <button
            type="submit"
            :disabled="loading"
            class="btn-bochas-rojo w-full flex items-center justify-center"
            :class="{ 'opacity-60 cursor-not-allowed': loading }"
          >
            <span v-if="!loading">Cambiar contraseña</span>
            <span v-else>Cambiando...</span>
          </button>
        </form>

        <div class="mt-6 text-center">
          <button
            type="button"
            @click="onLogout"
            class="text-xs text-gray-500 hover:text-gray-300 transition-colors"
          >
            Cancelar y cerrar sesión
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import { cambiarPassword, getStoredUser, logout } from "@/services/auth/authService";

const router = useRouter();
const loading = ref(false);
const error = ref("");

const form = ref({
  currentPassword: "",
  newPassword: "",
  confirmPassword: "",
});

const showCurrent = ref(false);
const showNew = ref(false);
const showConfirm = ref(false);

async function onSubmit() {
  error.value = "";

  if (form.value.newPassword.length < 6) {
    error.value = "La nueva contraseña debe tener al menos 6 caracteres.";
    return;
  }
  if (form.value.newPassword !== form.value.confirmPassword) {
    error.value = "Las contraseñas nuevas no coinciden.";
    return;
  }
  if (form.value.newPassword === form.value.currentPassword) {
    error.value = "La nueva contraseña debe ser distinta de la actual.";
    return;
  }

  const user = getStoredUser();
  if (!user || !user.id) {
    error.value = "No se pudo identificar al usuario. Iniciá sesión de nuevo.";
    return;
  }

  loading.value = true;
  try {
    await cambiarPassword({
      userId: user.id,
      currentPassword: form.value.currentPassword,
      newPassword: form.value.newPassword,
    });
    // Refrescar el user guardado para que mustChangePassword quede en false
    const stored = getStoredUser();
    if (stored) {
      stored.mustChangePassword = false;
      localStorage.setItem("bochas_user", JSON.stringify(stored));
    }
    // Redirigir al dashboard
    router.push("/admin");
  } catch (err) {
    error.value =
      err.response?.data?.message ||
      "No pudimos cambiar la contraseña. Intentá nuevamente.";
  } finally {
    loading.value = false;
  }
}

function onLogout() {
  logout();
  router.push("/login");
}
</script>
